var exports = {
  "k": "xe533113f--24e4ac--container",
  "_": "xe533113f--24e4ac--img",
};

module.exports = exports;
